'use client'
import type { ReactNode } from 'react'
import { cx } from '../utils'

export function FormField({
  label,
  hint,
  error,
  required,
  children,
}: {
  label: string
  hint?: string
  error?: string
  required?: boolean
  children: ReactNode
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="flex items-baseline justify-between gap-3">
        <span className="text-[13px] font-medium tracking-[0.08em] text-ink-2 uppercase">
          {label}
          {required && <span className="text-danger"> *</span>}
        </span>
        {hint && <span className="font-mono text-[13px] text-ink-3">{hint}</span>}
      </label>
      {children}
      {error && <p className="text-[13px] text-danger">{error}</p>}
    </div>
  )
}
